import { ApiFarmerRewards } from '@api/interfaces/ApiFarmerRewards';
import { Filter } from "@/components/DesignSystem/Toolbar/interfaces";
import { ChurnStatus } from "@shared/enums";
import { CustomerChurn } from '@/constants/constant';

export const getProgramReward = (
  farmerRewards: ApiFarmerRewards[] | undefined,
  programId: string,
) => {
  return farmerRewards?.find((reward) => reward.programId === programId);
};

export type ChartPosition = "left" | "center" | "right" | undefined;

export const getChurnStatusFilter = (): Filter => {
  const options = Object.values(ChurnStatus).map((status) => ({
    id: status,
    label: status,
  }));

  const id = 'churnStatus';
  return {
    id,
    label: CustomerChurn.filters[id],
    options,
    selectionMethod: 'multi-select',
  };
};
